import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const SkiJumping = () => {
  return (
    <SportsLayoutComp name={'Ski Jumping'}/>
  )
}

export default SkiJumping